import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import siteConfig from '../../configuration/siteConfiguration';


const DO_CHECK_ON_GLOBAL_MOUSE_CLICK = false; // Set to true if you want to enable click outside detection for dropdowns
const CURRENT_VIEW_IS_MOBILE = window.innerWidth < 768;

const assetUrl = `${siteConfig.assetBaseUrl}/icons/verticals-we-power/default`

// Navigation links configuration
const navLinks = [
  {
    label: 'Home',
    to: '/',
    type: 'link',
  },
  {
    label: 'Verticals we power',
    to: '/verticals-we-power',
    icon: '/images/verticalswepower.svg',
    type: 'link'
  },
  {
    label: 'Products',  /* Cognitva WEAVE™ */
    to: '/cip',
    type: 'link',
    type: 'dropdown',
    dropdownKey: 'whatWeBuild',
    subLinks: [
      {
        label: 'Cognitva WEAVE™',
        to: '/cip',
        icon: `/images/verticalswepower.svg`,
        // subtitle: 'Smarter Justice. Faster Outcomes.',
        className: 'active legal-tech',
        iconClass: 'legal-icon-submenu',
        contentClass: 'dropdown-item-content-submenu',
      },
      {
        label: 'Ideonix',
        to: 'https://ideonix.ai/',
        icon: `images/ideonix.png`,
        // subtitle: 'Smarter Justice. Faster Outcomes.',
        className: 'active legal-tech',
        iconClass: 'legal-icon-submenu',
        contentClass: 'dropdown-item-content-submenu',
        newTab: true
      },
      {
        label: 'AayuVault™',
        to: '/healthcare',
        icon: `${assetUrl}/Healthcare.svg`,
        className: 'active legal-tech',
        iconClass: 'legal-icon-submenu',
        contentClass: 'dropdown-item-content-submenu',
      },
      {
        label: 'AgniFlow™',
        to: '/manufacturing',
        icon: `${assetUrl}/ESG.svg`,
        className: 'health-tech',
        iconClass: 'health-icon-submenu',
        contentClass: 'dropdown-item-content-submenu',
        disabled: true
      },]
  },

  /*  {
      label: 'What we build',
      type: 'dropdown',
      dropdownKey: 'whatWeBuild',
      subLinks: [
        {
          label: 'Verticals we power',
          to: '/verticals-we-power',
          icon: '/images/verticalswepower.svg',
          subtitle: 'Overview',
          iconClass: 'legal-icon-submenu',
          contentClass: 'dropdown-item-content-submenu',
        },
        {
          label: 'Legal Tech',
          to: '/legal',
          icon: `${assetUrl}/Legal.svg`,
          subtitle: 'Smarter Justice. Faster Outcomes.',
          className: 'active legal-tech',
          iconClass: 'legal-icon-submenu',
          contentClass: 'dropdown-item-content-submenu',
        },
        {
          label: 'Health Tech',
          to: null,
          icon: `${assetUrl}/Healthcare.svg`,
          subtitle: 'AI for Better Care.',
          className: 'health-tech',
          iconClass: 'health-icon-submenu',
          contentClass: 'dropdown-item-content-submenu',
          disabled: true
        },
        {
          label: 'Fin Tech',
          to: null,
          icon: `${assetUrl}/Finance.svg`,
          subtitle: 'Intelligent Finance. Automated.',
          className: 'fin-tech',
          iconClass: 'fin-icon-submenu',
          contentClass: 'dropdown-item-content-submenu',
          disabled: true
        },
        {
          label: 'Reg Tech',
          to: null,
          icon: `${assetUrl}/Regulations.svg`,
          subtitle: 'Compliance Without Chaos.',
          className: 'reg-tech',
          iconClass: 'reg-icon-submenu',
          contentClass: 'dropdown-item-content-submenu',
          disabled: true
        },
        {
          label: 'ESG & Energy',
          to: null,
          icon: `${assetUrl}/ESG.svg`,
          subtitle: 'Sustainable Insights. Delivered.',
          className: 'reg-tech',
          iconClass: 'reg-icon-submenu',
          contentClass: 'dropdown-item-content-submenu',
          disabled: true
        }
      ],
    }, */
  {
    label: 'Who we are',
    type: 'dropdown',
    dropdownKey: 'whoWeAre',
    subLinks: [
      {
        label: 'About Us',
        to: '/about-us',
        icon: '/images/aboutus.svg',
        iconClass: 'legal-icon-submenu',
        contentClass: 'dropdown-item-content-submenu',
      },
      {
        label: 'Careers',
        to: '/careers',
        icon: '/images/careers.svg',
        hiring: true,
        iconClass: 'legal-icon-submenu',
        contentClass: 'dropdown-item-content-submenu',
      },
    ],
  },
  {
    label: 'Contact',
    to: '/contact',
    type: 'link',
  },
];

const Header = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isWhatWeBuildOpen, setIsWhatWeBuildOpen] = useState(false);
  const [isWhoWeAreOpen, setIsWhoWeAreOpen] = useState(false);

  const whatWeBuildRef = useRef(null);
  const whoWeAreRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Always show header when at the very top
      if (currentScrollY === 0) {
        setIsVisible(true);
      }
      // Hide header when scrolling down (after 50px threshold)
      else if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setIsVisible(false);
        // Close mobile menu if open when hiding header
        if (isMobileMenuOpen) {
          setIsMobileMenuOpen(false);
        }
        // Close dropdowns when scrolling
        setIsWhatWeBuildOpen(false);
        setIsWhoWeAreOpen(false);
      }
      // Show header when scrolling up
      else if (currentScrollY < lastScrollY) {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    // Use requestAnimationFrame for smoother performance
    let ticking = false;
    const handleScrollThrottled = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScrollThrottled, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScrollThrottled);
    };
  }, [lastScrollY, isMobileMenuOpen]);

  // Close dropdowns when clicking outside
  useEffect(() => {

    const handleClickOutside = (event) => {
      if (CURRENT_VIEW_IS_MOBILE && !DO_CHECK_ON_GLOBAL_MOUSE_CLICK) return;// disabling for the time being
      let targetElement = event?.target;
      const isInside = (ref) => {
        while (targetElement) {
          if (ref.current && ref.current === targetElement) {
            return true;
          }
          targetElement = targetElement.parentNode;
        }
        return false;
      };

      // Reset targetElement for next check
      targetElement = event.target;
      const isInsideWhatWeBuildRef = isInside(whatWeBuildRef);
      targetElement = event.target;
      const isInsideWhoWeAreRef = isInside(whoWeAreRef);
      console.log('inside check result :', { isInsideWhatWeBuildRef, isInsideWhoWeAreRef });
      if (whatWeBuildRef.current && !isInsideWhatWeBuildRef) {
        console.log('Clicked outside What We Build dropdown');
        setIsWhatWeBuildOpen(false);
      }

      if (whoWeAreRef.current && !isInsideWhoWeAreRef) {
        console.log('Clicked outside Who We Are dropdown');
        setIsWhoWeAreOpen(false);
      }

    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleMobileNavClick = (path, e) => {
    console.log('Mobile nav item clicked:', path);
    e?.stopPropagation();
    e?.preventDefault();

    if (path) {
      window.location.href = path;
    }
  };

  const toggleWhatWeBuild = () => {
    //console.log('Toggling What We Build dropdown - current state:', isWhatWeBuildOpen);
    setIsWhatWeBuildOpen(!isWhatWeBuildOpen);
    setIsWhoWeAreOpen(false); // Close other dropdown
  };

  const toggleWhoWeAre = () => {
    //console.log('inside toggleWhoWeAre - current state:', isWhoWeAreOpen);
    setIsWhoWeAreOpen(!isWhoWeAreOpen);
    setIsWhatWeBuildOpen(false); // Close other dropdown
  };

  const NavLinkClass = (path) => {
    const currentPath = location.pathname.toLowerCase();
    if (!path) return 'nav-item';
    return currentPath === path.toLowerCase() ? 'nav-item nav-item-current' : 'nav-item';
  }


  return (
    <>
      <header className={`header ${isVisible ? 'header-visible' : 'header-hidden'}`}>
        <div className="header-container">
          {/* Desktop Layout */}
          <div className="desktop-layout">
            <div className="logo-section">
              <Link to="/" >
                <img src="companylogo.svg" alt="Cognitva.ai logo" className="logo-full" />
              </Link>
            </div>
            <div className="right-section">
              <nav className="navigation">
                {navLinks.map((nav, idx) => {
                  if (nav.type === 'link') {
                    return (
                      <Link key={nav.label} to={nav.to} className={NavLinkClass(nav.to)}>{nav.label}</Link>
                    );
                  }
                  if (nav.type === 'dropdown' && nav.dropdownKey === 'whatWeBuild') {
                    return (
                      <div className={`${NavLinkClass(nav.to)} dropdown`} ref={whatWeBuildRef} key={nav.label}>
                        <div className="dropdown-trigger" onClick={toggleWhatWeBuild}>
                          <span>{nav.label}</span>
                          <svg
                            className={`dropdown-icon ${isWhatWeBuildOpen ? 'rotated' : ''}`}
                            width="12"
                            height="8"
                            viewBox="0 0 12 8"
                          >
                            <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" fill="none" />
                          </svg>
                        </div>
                        {isWhatWeBuildOpen && (
                          <div className="dropdown-menu">
                            {nav.subLinks.map((sub, subIdx) => (
                              <Link
                                to={sub.to}
                                className={`dropdown-item${sub.className ? ' ' + sub.className : ''}`}
                                onClick={() => setIsWhatWeBuildOpen(false)}
                                key={sub.label}
                                target={sub.newTab ? '_blank' : '_self'}
                              >
                                <div className={`dropdown-item-icon${sub.iconClass ? ' ' + sub.iconClass : ''}`}>
                                  <img height={32} src={sub.icon} alt={sub.label} className="dropdown-svg-icon" />
                                </div>
                                <div className={sub.contentClass || 'dropdown-item-content'}>
                                  <div className="dropdown-item-title">{sub.label}</div>
                                  {sub.subtitle && <div className="dropdown-item-subtitle">{sub.subtitle}</div>}
                                </div>
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  }
                  if (nav.type === 'dropdown' && nav.dropdownKey === 'whoWeAre') {
                    return (
                      <div className={`${NavLinkClass(nav.to)} dropdown`} ref={whoWeAreRef} key={nav.label}>
                        <div className="dropdown-trigger" onClick={toggleWhoWeAre}>
                          <span>{nav.label}</span>
                          <svg
                            className={`dropdown-icon ${isWhoWeAreOpen ? 'rotated' : ''}`}
                            width="12"
                            height="8"
                            viewBox="0 0 12 8"
                          >
                            <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" fill="none" />
                          </svg>
                        </div>
                        {isWhoWeAreOpen && (
                          <div className="dropdown-menu">
                            {nav.subLinks.map((sub, subIdx) => (
                              <Link
                                to={sub.to}
                                className="dropdown-item"
                                onClick={() => setIsWhoWeAreOpen(false)}
                                key={sub.label}
                              >
                                <div className="dropdown-item-icon">
                                  <img src={sub.icon} alt={sub.label} className="dropdown-svg-icon" />
                                </div>
                                <div className="dropdown-item-content">
                                  <div className="dropdown-item-title">
                                    {sub.label} {sub.hiring && <span className="hiring-badge">WE'RE HIRING</span>}
                                  </div>
                                </div>
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  }
                  return null;
                })}
              </nav>
              <button className="cta-nav-item" onClick={() => window.location.href = '/contact'}>
                Request for demo
              </button>
            </div>
          </div>

          {/* Mobile Layout */}
          <div className="mobile-layout">
            <div className="mobile-logo-section">
              <Link to="/" ><img src="companylogo.svg" alt="Cognitva.ai logo" className="logo-mobile" /></Link>
            </div>
            <div className="mobile-center-section">
              <button className="mobile-cta-button" onClick={() => window.location.href = '/contact'}>
                Request for demo
              </button>
            </div>
            <button className="mobile-menu-button" onClick={toggleMobileMenu}>
              <div className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay">
          <div className="mobile-navigation">
            {navLinks.map((nav, idx) => {
              if (nav.type === 'link') {
                return (
                  <Link key={nav.label} to={nav.to}>
                    <div className="mobile-nav-item" onClick={() => handleMobileNavClick(nav.to)}>{nav.label}</div>
                  </Link>
                );
              }
              if (nav.type === 'dropdown' && nav.dropdownKey === 'whatWeBuild') {
                return (<>
                  <div className="mobile-nav-item mobile-dropdown" onClick={toggleWhatWeBuild} ref={whatWeBuildRef} >
                    <span>{nav.label}</span>
                    <svg
                      className={`dropdown-icon ${isWhatWeBuildOpen ? 'rotated' : ''}`}
                      width="12"
                      height="8"
                      viewBox="0 0 12 8"
                    >
                      <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" fill="none" />
                    </svg>
                  </div>
                  {
                    isWhatWeBuildOpen && (
                      <div className="mobile-dropdown-menu">
                        {nav.subLinks.map((sub) => (
                          <Link
                            to={sub.to}
                            className="mobile-dropdown-item"
                            key={sub.label}
                            onClick={(e) => handleMobileNavClick(sub.to, e)}
                          >
                            <div className={`dropdown-item-icon${sub.iconClass ? ' ' + sub.iconClass : ''}`}>
                              <img height={32} src={sub.icon} alt={sub.label} className="dropdown-svg-icon" />
                            </div>
                            <div className={sub.contentClass || 'dropdown-item-content'}>
                              <div className="dropdown-item-title">{sub.label}</div>
                              {sub.subtitle && <div className="dropdown-item-subtitle">{sub.subtitle}</div>}
                            </div>
                          </Link>
                        ))}
                      </div>
                    )
                  }</>
                )
              }
              if (nav.type === 'dropdown' && nav.dropdownKey === 'whoWeAre') {
                return (<>
                  <div className="mobile-nav-item mobile-dropdown" onClick={toggleWhoWeAre} ref={whoWeAreRef}>
                    <span>{nav.label}</span>
                    <svg
                      className={`dropdown-icon ${isWhoWeAreOpen ? 'rotated' : ''}`}
                      width="12"
                      height="8"
                      viewBox="0 0 12 8"
                    >
                      <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" fill="none" />
                    </svg>
                  </div>
                  {
                    isWhoWeAreOpen && (
                      <div className="mobile-dropdown-menu">
                        {nav.subLinks.map((sub, subIdx) => (
                          <Link
                            to={sub.to}
                            className="mobile-dropdown-item"
                            key={sub.label}
                            onClick={(e) => handleMobileNavClick(sub.to, e)}
                          >
                            <div className={`dropdown-item-icon${sub.iconClass ? ' ' + sub.iconClass : ''}`}>
                              <img height={32} src={sub.icon} alt={sub.label} className="dropdown-svg-icon" />
                            </div>
                            <div className={sub.contentClass || 'dropdown-item-content'}>
                              <div className="dropdown-item-title">{sub.label}</div>
                              {sub.subtitle && <div className="dropdown-item-subtitle">{sub.subtitle}</div>}
                            </div>
                          </Link>
                        ))}
                      </div>
                    )
                  }
                </>)
              }
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default Header;